import type { User } from "../../models/User";
import type { WPNavigationLink } from "../../models/WPNavigationLink";
import type {
  WPPageDescriptor,
  WPPageGroupDescriptor,
} from "../../models/WPPageDescriptor";
import { configRefs } from "../constants/config";
import { DAYS_TO_MS, HOURS_TO_MS } from "../constants/time";
import { createCache } from "../createCache";
import { isPageDescriptor } from "../guards/isPageDescriptor";

import type { ApiClientOptions } from "./typings/ApiClientOptions";
import type { ApiRequestInterceptor } from "./typings/ApiRequestInterceptor";
import { fetchRequest } from "./utils/fetchRequest";

export function makeFetchNavigation(
  requestInterceptor: ApiRequestInterceptor,
  options: ApiClientOptions,
) {
  const cache = createCache<
    Array<WPPageDescriptor | WPPageGroupDescriptor | WPNavigationLink>
  >({
    timeToLiveMs: 1 * HOURS_TO_MS,
    timeToEvictMs: 1 * DAYS_TO_MS,
    ...options,
  });

  return (user: User | undefined) => {
    const userType = user?.type ?? "guest";

    return cache(userType, async () => {
      const response = await fetchRequest<{
        items: Array<
          WPPageDescriptor | WPPageGroupDescriptor | WPNavigationLink
        >;
      }>(
        requestInterceptor(
          `${await configRefs.apis.webproever.get()}/konfiguration/topmenu/?user-role=${userType}`,
        ),
      );

      // the first item in the response is always the main page, overrule the
      // path in case SiteCore isn't aware of this
      const firstPage = response.items.find(isPageDescriptor);

      if (firstPage) {
        firstPage.path = "/";
      }

      return response.items;
    });
  };
}
